export enum TemplateName {
  PDP = 'AccommodationPage',
}

function matchesTemplate(templateName: TemplateName, receivedString: string | undefined = ''): boolean {
  return receivedString === templateName.toString();
}

export default { matchesTemplate };
